import React from 'react'
import { observer } from 'mobx-react-lite'

import { CurrencyInput, ListItemAction, useGlobalCopyStore, useGoalStore } from '../../../common'
import { Goal, TrackType } from '../../../core'
import { formatCurrency } from '../../../core/utils/NumberFormatting'

interface AmountToSaveActionProps {
  goal: Goal
}

export const AmountToSaveAction = observer(({ goal }: AmountToSaveActionProps) => {
  const { goals: copy } = useGlobalCopyStore()
  const { setAlert, setSelectedGoal, updateGoal, updateRetirementGoal } = useGoalStore()

  const [amount, setAmount] = React.useState<number>(goal.amount)

  const isNew = !goal.guid
  const isInvalid = amount < 0 || amount > 99999999.99
  const isDisabled =
    (goal.track_type === TrackType.SAVINGS_TRACK && goal.has_been_spent) ||
    (goal.track_type !== TrackType.SAVINGS_TRACK && goal.is_complete)

  const handleSave = async () => {
    const updatedGoal = { ...goal, amount }
    goal.amount = amount
    if (isNew) {
      setSelectedGoal(updatedGoal)
    } else {
      if (goal.track_type !== TrackType.RETIREMENT_TRACK) {
        await updateGoal(updatedGoal)
      } else {
        await updateRetirementGoal(updatedGoal)
      }

      setAlert(copy.alert_goal_updated_amount)
    }
  }

  const handleCancel = () => {
    setTimeout(() => {
      setAmount(goal.amount)
    }, 250)
  }

  return (
    <ListItemAction
      isDisabled={isDisabled}
      isSaveDisabled={isInvalid}
      label={copy.details_amount_to_save}
      onCancel={handleCancel}
      onSave={handleSave}
      primaryText={copy.details_amount_to_save}
      secondaryText={formatCurrency(goal.amount, '0,0')}
      zeroStateText={isNew && goal.amount === 0 ? copy.add_amount : undefined}
    >
      <CurrencyInput
        amount={amount}
        autoFocus={true}
        error={isInvalid}
        fullWidth={true}
        minAmount={0}
        setAmount={(v) => setAmount(!isNaN(Number(v)) ? Number(v) : amount)}
        sx={{ '.MuiTypography-body1': { p: 0 } }}
      />
    </ListItemAction>
  )
})
